export default __webpack_public_path__ + "static/media/Sites.b32a2a73.jpg";